import { Util } from '@grandvisionhq/forms';
import { useAdyen } from '@grandvisionhq/payments';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import '@grandvisionhq/utils';
import { ApplePaySessionErrors } from '../../../../../mappers/errors-mapping.js';

// apple doesnt validate all shipping data for all countries. For example, for Spain it doesn't
const isPostalCodeValid = (country, postalCode)=>{
    if (!postalCode) return false;
    // In this case we can't do the full validation, because if the postal code includes a space, apple will only return the part before the space plus the space at the end. (bug).
    // for example: "W1S 3BE" will be returned here as "W1S "
    // this data IS fully validated again after the payment authorization
    if (postalCode.charAt(postalCode.length - 1) === ' ') return true // checks if the last character is equal to a space
    ;
    return country && postalCode && Util.validations.isValidPostalCodeForCountry(country, postalCode);
};
const useValidateShippingData = ()=>{
    var ref1;
    const { getLabel , country  } = useIntl();
    const { featureConfigs , allowAlternativeShippingState  } = useFeatureToggles();
    const { config  } = useAdyen();
    const addressValidations = config === null || config === void 0 ? void 0 : (ref1 = config.applepay) === null || ref1 === void 0 ? void 0 : ref1.addressValidation;
    return (applePayShippingContactSelectedEvent, session, paymentRequest)=>{
        try {
            const { shippingContact  } = applePayShippingContactSelectedEvent;
            let valid = true;
            if (shippingContact.countryCode !== country) {
                session.completeShippingContactSelection({
                    newTotal: paymentRequest.total,
                    errors: [
                        new ApplePayError('shippingContactInvalid', 'country', getLabel(ApplePaySessionErrors.ApplePayInvalidAddress)), 
                    ]
                });
                valid = false;
            }
            if (!isPostalCodeValid(shippingContact.countryCode, shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.postalCode)) {
                session.completeShippingContactSelection({
                    newTotal: paymentRequest.total,
                    errors: [
                        new ApplePayError('shippingContactInvalid', 'postalCode', getLabel('checkout.address.postalCode.errorMessage')), 
                    ]
                });
                valid = false;
            }
            if (allowAlternativeShippingState && featureConfigs.alternativeShippingRegex) {
                const postalCodeIsInvalid = (shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.postalCode) && featureConfigs.alternativeShippingRegex.test(shippingContact.postalCode);
                if (postalCodeIsInvalid) {
                    session.completeShippingContactSelection({
                        newTotal: paymentRequest.total,
                        errors: [
                            new ApplePayError('shippingContactInvalid', 'postalCode', getLabel('checkout.address.postalCode.unavailable.errorMessage')), 
                        ]
                    });
                    valid = false;
                }
            }
            if (!shippingContact.locality) {
                session.completeShippingContactSelection({
                    newTotal: paymentRequest.total,
                    errors: [
                        new ApplePayError('shippingContactInvalid', 'locality', getLabel('checkout.address.city.errorMessage')), 
                    ]
                });
                valid = false;
            }
            if ((addressValidations === null || addressValidations === void 0 ? void 0 : addressValidations.firstName) && !(addressValidations === null || addressValidations === void 0 ? void 0 : addressValidations.firstName((shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.givenName) || ''))) {
                session.completeShippingContactSelection({
                    newTotal: paymentRequest.total,
                    errors: [
                        new ApplePayError('shippingContactInvalid', 'name', getLabel('checkout.address.firstName.errorMessage')), 
                    ]
                });
                valid = false;
            }
            if ((addressValidations === null || addressValidations === void 0 ? void 0 : addressValidations.lastName) && !(addressValidations === null || addressValidations === void 0 ? void 0 : addressValidations.lastName((shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.familyName) || ''))) {
                session.completeShippingContactSelection({
                    newTotal: paymentRequest.total,
                    errors: [
                        new ApplePayError('shippingContactInvalid', 'name', getLabel('checkout.address.lastName.errorMessage')), 
                    ]
                });
                valid = false;
            }
            if ((addressValidations === null || addressValidations === void 0 ? void 0 : addressValidations.streetName) && (shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.addressLines)) {
                const addressLinesValid = shippingContact.addressLines.every((line)=>{
                    var ref;
                    return addressValidations === null || addressValidations === void 0 ? void 0 : (ref = addressValidations.streetName) === null || ref === void 0 ? void 0 : ref.call(addressValidations, line);
                });
                if (!addressLinesValid) {
                    session.completeShippingContactSelection({
                        newTotal: paymentRequest.total,
                        errors: [
                            new ApplePayError('shippingContactInvalid', 'addressLines', getLabel('checkout.address.streetName.errorMessage')), 
                        ]
                    });
                    valid = false;
                }
            }
            return valid;
        } catch (e) {
            // Swallow InvalidAccessError
            if (!(e instanceof Error && e.name === 'InvalidAccessError')) {
                throw e;
            }
            return true;
        }
    };
};

export { useValidateShippingData };
//# sourceMappingURL=use-validate-shipping-data.js.map
